import { Button, UploadFile } from "antd";
import Upload, { UploadChangeParam } from "antd/es/upload";
import { useState } from "react";
import DownloadIcon from "../../assets/icons/DownloadIcon";

interface Props {
  handler: (data: FormData) => void;
  isLoading?: boolean;
  downloadLink?: string;
  accept?: string;
  label?: string;
  className?: string;
  labelClass?: string;
}

export default function Uploader({
  handler,
  isLoading,
  downloadLink,
  accept,
  label,
  className = "",
  labelClass = "",
}: Props) {
  const [filename, setFilename] = useState<string | null>(null);
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleUpload = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("name", file.name);

    setFilename(file.name);

    handler(formData);
    return;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFileList(info.fileList);

    if (info.file.status === "removed") {
      setFilename("No file chosen");
    }
  };

  return (
    <div className={`my-6 ${className}`}>
      {label ? (
        <label
          className={`text-body text-sm font-medium leading-normal ${labelClass}`}
        >
          {label}
        </label>
      ) : null}
      <Upload
        name="photo"
        beforeUpload={handleUpload}
        maxCount={1}
        accept={accept}
        showUploadList={false}
        onChange={handleChange}
        fileList={fileList}
        className="h-full block py-1.5"
        disabled={isLoading}
      >
        <Button
          className="flex items-center !justify-start !p-0 !border-display-light rounded-md"
          block
        >
          <span className="!flex justify-center items-center px-3 bg-[#5e718d] text-white h-full rounded-s-md">
            Browse file
          </span>
          <div className="px-2.5 gap-2 text-sm font-medium text-extra-gray overflow-hidden whitespace-nowrap text-ellipsis">
            {isLoading ? (
              "Uploading..."
            ) : (
              <span
                className="overflow-hidden text-ellipsis"
                style={{
                  direction: "unset",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {filename || "No file chosen"}
              </span>
            )}
          </div>
        </Button>
      </Upload>

      {downloadLink ? (
        <div className="flex items-center gap-1.5">
          <span className="text-body-text text-sm leading-normal">
            Download Sample File
          </span>
          <Button
            className="download-button !p-0 !h-fit !border-none !shadow-none !font-semibold"
            size="small"
            icon={<DownloadIcon />}
            type="link"
            href={downloadLink}
            target="_blank"
            download
          >
            Download
          </Button>
        </div>
      ) : null}
    </div>
  );
}
